import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { CloseBtn, Spinner } from 'src/components/basic';

import { getRouter, scssVariables, useLanguage, useScreenDetail } from 'src/helpers';
import model from './model';

const ContentComponent = ({ Component, ...props }) => {
  let language = useLanguage();
  let screenDetail = useScreenDetail();

  return (
    <Component
      router={{
        ...getRouter(),
        navigate: (url, params) => {
          model.emit('router_navigate', { url, params });
        }
      }}
      language={language}
      screenDetail={screenDetail}
      {...props}
    />
  );
};
export class Popup extends BaseComponent {
  state = { activePopups: [] };
  componentDidMount() {
    console.log('Popup mounted', model.state.popups);
    model.subscribe(this.subscription);
    model.on('onChangePopup', this.onChangePopup);
    this.setState({ activePopups: [...model.state.popups] });
    let activePopup = model.getActivePopup()[0];
    if (activePopup) this.onChangePopup(activePopup);
    model.view = this;
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('onChangePopup', this.onChangePopup);
    console.log('Popup unmounted', model.state.popups);
    clearTimeout(this.timeout);
    model.view = null;
  }

  sync = () => {
    // console.log('sync popup');
    this.setState({ activePopups: [...model.state.popups] });
    // let activePopup = model.getActivePopup()[0];
    // if (activePopup) this.onChangePopup(activePopup);
  };

  onChangePopup = (activePopup) => {
    // console.log('onChangePopup 1');
    this.setState({ activePopups: [...model.state.popups] });
    if (activePopup) {
      this.timeout = setTimeout(() => {
        const activePopups = model.state.popups.map((item) => {
          if (activePopup.id === item.id) {
            // check login or not
            if (item.active) {
              item.allow = true;
              // console.log('onChangePopup 2');
            }
          }
          return item;
        });
        this.setState({ activePopups });
      }, 100);
    }
  };

  renderContain = (index) => {
    if (!this.state.activePopups[index].active) {
      return null;
    }
    if (this.state.activePopups[index].id.includes('loading')) {
      return <Spinner />;
    }
    const closeBtn = (
      <CloseBtn
        className={'mc-popup-close-btn '}
        onClose={this.hide(index)}
        style={{}}
        fill={scssVariables['colors-mc-primary']}
        iconProps={{ 'data-testid': 'popup-close-button' }}
      />
    );
    const Comp = this.state.activePopups[index]?.component;
    if (Comp) {
      return (
        <ContentComponent
          Component={Comp}
          hide={this.hide(index)}
          closeBtn={closeBtn}
          {...this.state.activePopups[index]?.props}
        />
      );
    }
    return (
      <div className='mc-popup-contain'>
        <div className='mc-modal-header'>
          <div className='mc-popup-title' />
          {closeBtn}
        </div>
        <div className='mc-modal-body' />
        <div className='mc-modal-footer' />
      </div>
    );
  };
  hide = (index) => () => {
    const activePopup = this.state.activePopups[index];
    if (activePopup) {
      if (activePopup.afterHide) {
        activePopup.afterHide();
      }
      model.setActivePopup(activePopup.id, { ...activePopup, active: false, allow: false });
    }
  };
  render() {
    const activePopups = this.state.activePopups;
    // console.log('popup render 2', activePopups);

    const orderActive = this.state.activePopups
      .filter((item) => item.allow && item.active)
      .sort((a, b) => a.time - b.time);
    const firstActive = orderActive[0];

    return (
      <>
        {activePopups
          .sort((a, b) => a.time - b.time)
          .map((item, index) => {
            // console.log('item render', { ...item }, index);
            let otherCondition = !item.showAlone;
            if (firstActive?.showAlone) {
              otherCondition = item.id === firstActive.id;
            }

            return (
              <div
                key={'popup-' + item.id}
                data-testid='popup-root'
                data-popup-id={item?.id || ''}
                className={
                  'mc-popup ' +
                  (item && item.allow && otherCondition ? 'show' : 'hide') +
                  (item && item.id ? ' mc-popup-' + item.id : '')
                }
                style={{ zIndex: 10 + index }}
              >
                <div className={'mc-popup-transfer'}>
                  <div
                    data-testid='popup-cover'
                    className={'mc-popup-cover ' + (item && item.allow ? 'show' : 'hide')}
                    onClick={() => {
                      if (
                        item.id === 'record_video' ||
                        item.id.includes('loading') ||
                        item.noHideOutSide
                      ) {
                        return;
                      }
                      this.hide(index)();
                    }}
                  />
                  {this.renderContain(index)}
                </div>
              </div>
            );
          })}
      </>
    );
  }
}
